import React from 'react';

import * as sc from './styles';

export interface LoadingProps {
  small?: boolean;
}

export const Loading = (props: LoadingProps) => {
  return (
    <sc.Wrapper {...props}>
      <span />
      <span />
    </sc.Wrapper>
  );
};
try {
    // @ts-ignore
    Loading.displayName = "Loading";
    // @ts-ignore
    Loading.__docgenInfo = { "description": "", "displayName": "Loading", "props": { "small": { "defaultValue": null, "description": "", "name": "small", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Loading/Loading.tsx#Loading"] = { docgenInfo: Loading.__docgenInfo, name: "Loading", path: "src/components/Loading/Loading.tsx#Loading" };
}
catch (__react_docgen_typescript_loader_error) { }